import { breakpoints } from "@thkStore/theme/post/breakpoints";
import { button } from "@thkStore/theme/post/button";
import { colors } from "@thkStore/theme/post/colors";
import { datePicker } from "@thkStore/theme/post/datePicker";
import { globalStyle } from "@thkStore/theme/post/globalStyle";
import { modal } from "@thkStore/theme/post/modal";
import { typography } from "@thkStore/theme/post/typography";

export const postTheme = {
    colors,
    typography,
    button,
    globalStyle,
    breakpoints,
    modal,
    datePicker,
};